/* eslint-disable ember/no-classic-components, ember/no-computed-properties-in-native-classes, ember/require-tagless-components, no-restricted-properties, warp-drive/no-legacy-request-patterns */
import Component from '@ember/component';
import { action, computed } from '@ember/object';
import { service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import PersonType from '@linc-technologies/linced-common/enums/person-type';

export default class TeacherManager extends Component {
  // Services
  @service
  store;

  @service
  toaster;

  @tracked
  dialogOpen = false;
  event = null;
  @tracked
  oldTeacherGroupMappings = null;
  @tracked
  staff = null;

  @computed(
    'oldTeacherGroupMappings.@each.teacherCount',
    'event.teacherGroupMappings.@each.teacherCount',
  )
  get mappingsMatch() {
    return this.oldTeacherGroupMappings.every((mapping, index) => {
      return (
        JSON.stringify(mapping.teacherIds.toArray()) ===
        JSON.stringify(
          this.event.teacherGroupMappings.objectAt(index).teacherIds.toArray(),
        )
      );
    });
  }

  @computed('staff.[]', 'event.teacherGroupMappings.@each.teacherCount')
  get remainingTeachers() {
    let mappedTeachers = this.event.teacherGroupMappings.reduce(
      (teachers, mapping) => {
        teachers.push(...mapping.teachers);
        return teachers;
      },
      [],
    );
    return this.staff.filter((staff) => {
      return !mappedTeachers.some(function (teacher) {
        return staff.id === teacher.id;
      });
    });
  }

  @computed('event.teacherGroupMappings.@each.teacherCount')
  get teacherGroupMappingValid() {
    return this.event.teacherGroupMappings.every((mapping) => {
      return mapping.teacherCount !== 0;
    });
  }

  @action
  openDialog() {
    this.staff = this.store
      .peekAll('person')
      .filter((person) => person.type === PersonType.STAFF);

    this.oldTeacherGroupMappings = this.event.teacherGroupMappings.copy(true);
    this.dialogOpen = true;
  }

  @action
  closeDialog() {
    this.event.rollbackAttributes();
    this.dialogOpen = false;
  }

  @action
  save() {
    this.event
      .save()
      .then(() => {
        this.toaster.success('Teacher Assignments updated successfully!');
      })
      .catch(() => {
        this.toaster.error('Error updating Teacher Assignments!');
      })
      .finally(() => {
        this.dialogOpen = false;
      });
  }

  @action
  addTeacher(mapping, teacher) {
    mapping.teacherIds.pushObject(teacher.id);
  }

  @action
  removeTeacher(mapping, teacher) {
    mapping.teacherIds.removeObject(teacher.id);
  }
}
